import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DealModel } from 'ts/package/interfaces/PackageOfflineResponse';
import { checkAHAVI, replaceHtmlToStr } from 'utils/utils';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface HotelSummaryProps {
  deal: DealModel;
}

const HotelSummary: FC<HotelSummaryProps> = ({ deal }) => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="text-md text-bold mb-5 text-contrast">{t('hotel.name')}</div>
      <div className="mb-20">{deal.package.hoteltDesc}</div>
      <div className="text-md text-bold mb-5 text-contrast">{t('hotel.desc')}</div>
      <div
        className={checkAHAVI(deal.package.hotelRemarks) ? 'text-right-only' : ''}
        dangerouslySetInnerHTML={{ __html: replaceHtmlToStr(deal.package.hotelRemarks) }}
      ></div>
    </div>
  );
};

export default withErrorBoundary(HotelSummary, 'HotelSummary');
